var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user',{attrs:{"id":_vm.$store.state.user.currentUser.id}})}
var staticRenderFns = []

export { render, staticRenderFns }